export const previousPointHasLineData = (points, point) => {
    const currentIndex = points.indexOf(point);
    return currentIndex - 1 >= 0 && points[currentIndex - 1].lineToNext;
};

export const getLineData = (point, lines, points ) => {
    const lineData = lines[points.indexOf(point) - 1];
    return lineData;
};
